const Strings = {
    http: 'http:',
    https: 'https:',
    holidayClosed: 'HOLIDAY_CLOSED',
    holidayOpen: 'HOLIDAY_OPEN',
    toTime: '23:59',
    fromTime: '00:00',
    doubleSlash: '//',
    id: 'sys.contentType.sys.id',
    imageUrl: 'fields.mobileImage.fields.file.url',
    fileUrl: 'fields.file.url',
    buttonText: 'fields.button.fields.buttonText',
    headline: 'fields.headline',
    backgroundTextColor: 'fields.background',
    greenTick: 'greenTick',
    grayTick: 'grayTick',
    first: 'first',
    secound: 'secound',
    third: 'third',
    fourth: 'fourth',
    showOrderNow: 'Show Order Now Button',
    carousalContent: 'fields.carousalContent',
    homePageBanner: 'homepage_hero_banner',
    analyticsData: 'fields.analyticsData.fields',
    home: 'Home',
    account: 'Account',
    more: 'More',
    cart: 'Cart',
    tel: 'tel:',
    yes: 'yes',
    black: 'Black',
    invalidated: 'Invalidated',
    kfcImageType: 'moreContent.fields.header.fields.headerSection[0].fields.desktopImage.fields.file.contentType',
    kfcImage: 'moreContent.fields.header.fields.headerSection[0].fields.desktopImage.fields.file.url',
    instagram: 'moreContent.fields.footer.fields.footerContent[0].fields.links[0].fields.icon.fields.mobileImage.fields.file.url',
    instagramImageType: 'moreContent.fields.footer.fields.footerContent[0].fields.links[0].fields.icon.fields.mobileImage.fields.file.contentType',
    instagramLink: 'moreContent.fields.footer.fields.footerContent[0].fields.links[0].fields.externalurl',
    facebook: 'moreContent.fields.footer.fields.footerContent[0].fields.links[1].fields.icon.fields.mobileImage.fields.file.url',
    facebookImageType: 'moreContent.fields.footer.fields.footerContent[0].fields.links[1].fields.icon.fields.mobileImage.fields.file.contentType',
    facebookLink: 'moreContent.fields.footer.fields.footerContent[0].fields.links[1].fields.externalurl',
    twitter: 'moreContent.fields.footer.fields.footerContent[0].fields.links[2].fields.icon.fields.mobileImage.fields.file.url',
    twitterImageType: 'moreContent.fields.footer.fields.footerContent[0].fields.links[2].fields.icon.fields.mobileImage.fields.file.contentType',
    twitterLink: 'moreContent.fields.footer.fields.footerContent[0].fields.links[2].fields.externalurl',
    svgImageType: 'image/svg+xml',
    findKFCImage: 'moreContent.fields.header.fields.headerSection[5].fields.icon.fields.desktopImage.fields.file.url',
    offerAndDeals: 'moreContent.fields.header.fields.headerSection[1].fields.category',
    catering: 'moreContent.fields.header.fields.headerSection[2].fields.category',
    support: 'moreContent.fields.header.fields.headerSection[3].fields.category',
    legel: 'moreContent.fields.header.fields.headerSection[4].fields.category',
    findKFC: 'moreContent.fields.header.fields.headerSection[5].fields.linkText',
    copyRightText: 'moreContent.fields.footer.fields.footerContent[1].fields.headline',
    language: 'moreContent.sys.locale',
    logoImageUrl: 'moreContent.fields.logo.fields.desktopImage.fields.file.url',
    logoImageType: 'moreContent.fields.logo.fields.desktopImage.fields.file.contentType',
    rightArrow: 'fields.icon.fields.desktopImage.fields.file.url',
    rightArrowIconType: 'fields.icon.fields.desktopImage.fields.file.contentType',
    headerData: 'moreContent.fields.header.fields.headerSection',
    subHeaderData: 'moreContent.fields.header.fields.subHeaderSection',
    headerText: 'fields.linkText',
    dark: 'Dark',
    open: 'open',
    storeValue: 'name[0].value',
    distanceFromLocation: 'distance.distance.text',
    storeAddress: 'addresses[0].address.addressLines',
    app: 'app',
    nearbyStoresHttp: 'storeStatus.nearbyStoresSearch.httpMethod',
    nearbyStoresUrl: 'storeStatus.nearbyStoresSearch.url',
    googleDistanceUrl: 'storeStatus.googleDistance.url',
    googleDistDest: 'storeStatus.googleDistance.destination',
    googleDistKey: 'storeStatus.googleDistance.key',
    googleDistName: 'storeStatus.googleDistance.name',
    googleDistHttp: 'storeStatus.googleDistance.httpMethod',
    bulkStore: 'storeStatus.bulkStore',
    delivery: 'delivery',
    commaSeparator: ',',
    pipeSeparator: '|',
    geoLocation: 'geolocationResult[0].geometry.location',
    link: 'link',
    am: 'am',
    pm: 'pm',
    orderServName: 'fields.name',
    externalLink: 'params.externalurl',
    externalLinkTitle: 'params.linkText',
    distance: 'distance.distance.value',
    km: 'km',
    metric: 'metric',
    imperial: 'imperial',
    origins: 'storeStatus.googleDistance.origins',
    futureDate: 'timings.futureDates[0]',
    currentStatus: 'status.currentStatus',
    showScheduleOrder: 'tenantReducer.componentOptions.ScheduledDeliveryComponent.allowScheduleOrder',
    boundingBoxSizeMeters: 'storeSearch.boundingBoxSizeMeters',
    geohashprecision: 'storeSearch.geohashprecision',
    distanceMetrics: 'storeSearch.distanceMetrics',
    numOfStoresToShow: 'storeSearch.numOfStoresToShow',
    orderLookUpTitile: 'orderLookUpContent.fields.body[0].fields.title',
    orderNo: 'orderLookUpContent.fields.body[0].fields.content[0].fields.headline',
    placeHolder: 'orderLookUpContent.fields.body[0].fields.content[0].fields.subHeadline',
    cancelButton: 'orderLookUpContent.fields.body[0].fields.content[1].fields.buttonText',
    submitButton: 'orderLookUpContent.fields.body[0].fields.content[2].fields.buttonText',
    orderLookUpPageLink: 'Order Lookup',
    offerDealLink: 'Offers & Deals',
    giftCardLink: 'Gift Cards',
    supportLink: 'Support',
    findKFCLink: 'Find A KFC',
    createBaskets: 'createBaskets',
    validateBasket: 'validateBasket',
    helpPageLink: 'Get Help',
    storeAvailableTimeSlots: 'storeAvailableTimeSlots',
    storeAvailableAllTimeSlots: 'storeAvailableAllTimeSlots',
    dispositionName: 'fields.name',
    dispositionFields: 'fields.title',
    upsell: 'upsell',
    addons: 'addons',
    crosssell: 'crossell',
    veg: 'veg',
    servings: 'servings',
    ellipsis: '...',
    roundTheClock: '24x7',
    birthday: 'birthday',
    breakfast: 'breakfast',
    contactless: 'contactless',
    driveThru: 'driveThru',
    driveThruEvent: 'Drive Thru',
    inStoreEvent: 'In Store',
    kiosks: 'kiosks',
    parking: 'parking',
    phc: 'wheelchairAccess',
    playground: 'playground',
    refill: 'refill',
    restRoom: 'restRoom',
    terraces: 'terraces',
    wifi: 'freeWifi',
    rdpaccessibility: 'accessibility',
    rdpDriveThru: 'drive-thru-only',
    rdpwifi: 'wifi',
    rdpRestroom: 'restroom',
    foodCourt: 'foodCourt',
    pickup: 'pickup',
    specialEvent: 'christmas-ordering',
    restroom: 'restroom',
    driveThruOnly: 'drive-thru-only',
    accessibility: 'accessibility',
    wifiOnly: 'wifi',
    cateringType: 'catering',
    lineItemName: 'item.dname[0].value',
    currencySymbol: '₹',
    unitPrice: 'unitPrice',
    lineItemShortDescription: 'item.shortDescription[0].value',
    isCustomizable: 'item.customizable',
    quantity: 'quantity',
    foodLines: 'foodLines',
    foodLinesLength: 'foodLines.length',
    subtotal: 'subtotal',
    taxTotal: 'taxTotal',
    inclusiveTaxTotal: 'inclusiveTaxTotal',
    additionalChargeLines: 'additionalChargeLines[0]',
    additionalChargeLinesValue: 'additionalChargeLines[0].amount',
    addHopeDonate: 'response.addHopeContent.fields.donate',
    total: 'total',
    addHopeContent: 'response.addHopeContent',
    line1: 'fields.line1',
    line2: 'fields.line2',
    addHopeImageUrl: 'fields.image.fields.mobileImage.fields.file.url',
    lineItemId: 'item.id',
    addHopeId: 'items[0].id',
    promotion: 'Promotion',
    promotionName: 'name',
    addHopeName: 'name',
    addHope: 'Add Hope',
    carryBag: 'Carry Bag',
    products: 'products',
    deSelectAddHope: 'id',
    deliveryDistance: 'DeliveryDistance',
    pickupDistance: 'PickupDistance',
    allowedBanksForNetBanking: 'allowedBanksForNetBanking',
    momentWeekDay: 'dddd',
    everyDay: 'everyday',
    momentHoursAndMinutes: 'hh:mm',
    momentOf24HoursAndMinutes: 'HH:mm',
    dateTimeFormatHHmm: 'HHmm',
    colon: ':',
    takeaway: 'takeaway',
    paymentTenderImage: 'icon.fields.mobileImage.fields.file.url',
    paymentTenderImageType: 'icon.fields.mobileImage.fields.file.contentType',
    paymentImageTypeSvg: 'image/svg',
    paymentImageTypePng: 'image/png',
    paymentTenderImageWidth: 'icon.fields.mobileImage.fields.file.details.image.width',
    paymentTenderImageHeight: 'icon.fields.mobileImage.fields.file.details.image.height',
    sms: 'SMS',
    email: 'Email',
    deliveryInstruction: 'Delivery Instruction:',
    carDetails: 'Car Details:',
    inStore: 'in-store',
    driveThruCollectionPoint: 'drive-thru',
    curbside: 'curb-side',
    discountLinesName: 'discountLines[0].status.name',
    promoConditionStatus: 'discountLines[0].promoConditionStatus',
    basicErrors: 'discountLines[0].basicErrors',
    basicErrorsMessage: 'discountLines[0].basicErrors[0].message',
    promoCouponCode: 'discountLines[0].couponCode',
    promoAmount: 'discountLines[0].amount',
    featuredProducts: 'Featured Products',
    cardTypeVisa: 'visa',
    cardTypeAmex: 'american-express',
    cardTypeMaster: 'mastercard',
    cardTypeDinersClub: 'diners-club',
    cardTypeDiscover: 'discover',
    cardTypeJCB: 'jcb',
    paymentForBillDesk: 'paymentForBillDesk',
    dineIn: 'dine-in',
    showMap: 'showMap',
    useAddress: 'useAddress',
    address: 'address',
    postalCode: 'postalCode',
    prefecture: 'prefecture',
    cityTown: 'cityTown',
    chome: 'chome',
    streetDetailAddress: 'streetDetailAddress',
    apartmentName: 'apartmentName',
    roomNumber: 'roomNumber',
    companyName: 'companyName',
    specialNote: 'specialNote',
    switchDisposition: 'switchDisposition',
    menu: 'Menu',
    cateringCatalogType: 'Catering',
    weekdayInCaps: 'EVERYDAY',
    overAll: 'overAll',
    add: 'add',
    sub: 'sub',
    logout: 'logout',
    minutes: 'minutes',
    dateFormatYYYYMMDD: 'YYYY-MM-DD',
    invalidQRCode: 'invalidQRCode',
    invalidStore: 'invalidStore',
    invalidDisposition: 'invalidDisposition',
    storeClosed: 'CLOSED',
    storeOpen: 'OPEN',
    posFailed: 'sent-to-pos-failed',
    paymentFailed: 'payment-failed',
    posCompleted: 'sent-to-pos-completed',
    staged: 'staged',
    accepted: 'accepted',
    cancelledStatus: 'cancelled',
    checkedInStatus: 'checkedIn',
    collectedStatus: 'CheckedIn-Closed',
    logBeginCheckout: 'logBeginCheckout',
    logAddToCart: 'logAddToCart',
    logViewItemList: 'logViewItemList',
    logPurchase: 'logPurchase',
    logSelectItem: 'logSelectItem',
    setUserId: 'setUserId',
    logAddShippingInfo: 'logAddShippingInfo',
    editStore: 'editStore',
    editOrderType: 'editOrderType',
    deepLinkCategoryName: 'route.params.categoryName',
    deepLinkItemName: 'route.params.itemName',
    menuReqHeaderIfModifiedSince: 'If-Modified-Since',
    menuResHeaderLastModified: 'last-modified',
    view_item_list: 'view_item_list',
    created: 'created',
    assigned: 'assigned',
    pickedUp: 'picked-up',
    outForDelivery: 'out for delivery',
    arrived: 'arrived',
    delivered: 'delivered',
    cancel: 'cancel',
    cancelled: 'cancelled',
    estimatedArrival: 'Estimated Arrival',
    days: '07',
    rightArrowMobile: 'fields.icon.fields.mobileImage.fields.file.url',
    rightArrowIconTypeMobile: 'fields.icon.fields.mobileImage.fields.file.contentType',
    moreContent: 'moreContent.fields.footer.fields.footerContent[0].fields.links',
    socialIconTitle: 'fields.title',
    socialExternalURL: 'fields.externalurl',
    socialIconImageURL: 'fields.icon.fields.mobileImage.fields.file.url',
    usd: 'USD',
    phone: 'phone',
    orderItAgain: 'Order It Again',
    linkId: 'fields.linkId',
    calories: 'calories',
    video: 'Video',
    videoUrl: 'fields.mp4File.fields.file.url',
    generateClientTokenForBraintree: 'generateClientTokenForBraintree',
    breakfastTime: 'Breakfast',
    lunch: 'Lunch',
    snack: 'Snack',
    dinner: 'Dinner',
    enUs: 'en-US',
    timeFormatWithSecs24: 'HH:mm:ss',
    goToSettings: 'go to settings',
    redirectToApp: 'redirect to app',
    audioPermission: 'audio permission',
    priceWithoutTax: 'pricewithouttax',
    customProperties: 'customProperties',
    additionalProperties: 'additionalProperties',
    noStoreWithInRange: 'noStoreWithInRange',
    payByCash: 'pay-by-cash',
    localizedUserType: 'lo-guest',
    nonLocalizedUserType: 'non lo-guest',
    localizedMemberUserType: 'lo-member',
    nonLocalizedMemberUserType: 'non lo-member',
    checkedIn: 'checkedIn',
    zeroList: '(0)',
    hidden: 'hidden',
    googlePay: 'googlepay',
    applePay: 'applepay',
    paypal: 'paypal',
    creditCard: 'credit-card',
    dgftCreditCard: 'dgft-credit-card',
    dgftApplePay: 'dgft-applepay',
    giftCard: 'giftcard',
    canal: 'canal',
    deliveryOptions: 'deliveryOptions',
    route: 'route',
    streetAddress: 'street_address',
    neighborhood: 'neighborhood',
    sublocalitylevel1: 'sublocality_level_1',
    sublocalitylevel2: 'sublocality_level_2',
    sublocalitylevel3: 'sublocality_level_3',
    sublocality: 'sublocality',
    administrativeArealevel2: 'administrative_area_level_2',
    refundSuccess: 'refund-success',
    refundProgress: 'refund-progress',
    refundFailed: 'refund-failed',
    discountButton: 'componentOptions.app.cart.discountRemoveButton',
    trading: 'trading',
    hours: 'hours',
    kfc_restaurant: 'KFC RESTAURANT',
    termsOfUseLink: 'TermsOfUseLink',
    privacyPolicyLink: 'PrivacyPolicyLink',
    homepage: 'homepage',
    occasionpage: 'occasionpage',
    orderhistorypage: 'orderhistorypage',
    accountMyFavourites: 'Account - My Favourites',
    accountOrderHistory: 'Account - Order History',
    homePageOrderHistory: 'Homepage - Order History',
    transparent: 'Transparent',
    white: 'White',
    findKFCLinkID: 'findakfc',
    supportLinkID: 'support',
    nutritionallergenLinkID: 'nutritionallergen',
    headerLinkId: 'fields.linkId',
    favouriteorderLinkID: 'favouriteorder',
    accountLinkID: 'account',
    cookieLinkID: 'cookiesettings',
    kfcMenu: 'KFCAustraliaMenu',
    failure: 'failure',
    gPay: 'Google Pay',
    addtocart: 'addtocart',
    lo_guest: 'lo-guest',
    non_lo_guest: 'non lo-guest',
    closed: 'closed',
    integrated: 'integrated',
    hosted: 'hosted',
    braintree: 'braintree',
    billdesk: 'billdesk',
    cartCrossSell: 'cart cross-sell',
    android: 'android',
    order: 'order',
    paygate: 'paygate',
    globalpayment: 'globalpayment',
    japanpayments: 'japanpayments',
    text: 'text',
    linkText: 'linktext',
    input: 'input',
    checkbox: 'checkbox',
    note: 'note',
    emailKey: 'email',
    smsKey: 'sms',
    pushKey: 'push',
    telKey: 'tel',
    pattern: 'pattern',
    required: 'required',
    payu: 'payu',
    paymentInitiation: 'paymentInitiation',
    reorder: 'reorder',
    closed_unavailability: 'unavailability',
    transactionRequest: 'transactionRequest',
    checkedInNotCollected: 'checkedin-not_collected',
    checkedInRemake: 'checkedin-remake',
    checkedInClosed: 'checkedin-closed',
    checkedInAbandoned: 'checkedin-abandoned',
    newLine: '\n',
    staticLandingPage: 'staticLandingPage',
    Giftcard: 'Gift card',
    marketConfig: 'marketConfig',
    supportContent: 'supportContent',
    appRatings: 'appRatings',
    landingPage: 'landingPage',
    PLPDisclaimer: 'PLPDisclaimer',
    orderTracking: 'OrderTracking',
    onlyImage: 'only image',
    onlyText: 'only text',
    textAfterImage: 'text after image',
    readyForPosInjection: 'ready-for-pos-injection',
    header: 'header',
    selectedStore: 'selectedStore',
    cityOrTown: 'cityOrTown',
    active: 'Active',
    inActive: 'InActive',
    adyen: 'adyen',
    schema: 'schema',
    no: 'no',
};
export const PHONEPE_STATUS = {
    SUCCESS: 'success',
    FAILURE: 'failure',
};
export const PAYTM_STATUS = {
    SUCCESS: 'success',
    FAILURE: 'failure',
};
export const TENDERS_TITLE = {
    OTHER_WALLETS: 'other-wallet',
    GIFT_TITLE: 'Gift Card',
};
export const COUNTRY = {
    IND: 'in',
    AUS: 'au',
    ZAF: 'za',
    CAN: 'ca',
    JPN: 'jp',
    THA: 'th',
};
export const storeClosedErrorCode = ['BSDE006', 'BSDE008', 'BSDE0013'];
export const addCartErrorCode = 'BSIVE0003';
export const storeDispositionsErrorCodes = [...addCartErrorCode, 'BSEX001', 'BSIVE0001', 'BSIVE0002'];
export const storeStatusErrorCode = ['SOS003'];
export const validatebasketErrorCode = ['BSDE0012'];
export default Strings;
